import { render, staticRenderFns } from "./TqPricing.vue?vue&type=template&id=56d8d94f&scoped=true&"
import script from "./TqPricing.vue?vue&type=script&lang=js&"
export * from "./TqPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8d94f",
  null
  
)

export default component.exports